import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'

export default class DocumentsLinksList extends TemplateView {

    constructor() {
        super()

        this.state = {
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            },
            documentsBaseUrl: '',
            isProformaInvoice: false,
        }

        this.onAnyStatePropertyChanged(['documentUrls', 'documentsBaseUrl'], () => {
            this.$serviceAgreement.toggle(!!this.state.documentUrls['serviceAgreementUrl'])
            this.$dataProcessingAgreement.toggle(!!this.state.documentUrls['dataProcessingAgreementUrl'])
            this.$invoice.toggle(!!this.state.documentUrls['invoiceUrl'])
            this.$exhibit.toggle(!!this.state.documentUrls['serviceAgreementExhibitUrl'])

            this.$serviceAgreement.attr('href', this.state.documentsBaseUrl + '/' + this.state.documentUrls['serviceAgreementUrl'])
            this.$dataProcessingAgreement.attr('href', this.state.documentsBaseUrl + '/' + this.state.documentUrls['dataProcessingAgreementUrl'])
            this.$invoice.attr('href', this.state.documentsBaseUrl + '/' + this.state.documentUrls['invoiceUrl'])
            this.$exhibit.attr('href', this.state.documentsBaseUrl + '/' + this.state.documentUrls['serviceAgreementExhibitUrl'])
        })

        this.onStatePropertyChanged('isProformaInvoice', (isProformaInvoice) => {
            const invoiceTextKey = isProformaInvoice ? 'licenses.purchase.success.proforma_invoice_link' : 'licenses.purchase.success.invoice_link'
            this.$invoice.text(messageResource.getMessage(invoiceTextKey))
        })
    }

    templateHtml() {
        return '<div class="links">' +
               '    <a class="serviceAgreement" target="_blank"><%=serviceAgreement%></a>' +
               '    <a class="dataProcessingAgreement" target="_blank"><%=dataProcessingAgreement%></a>' +
               '    <a class="invoice" target="_blank"></a>' +
               '    <a class="exhibit" target="_blank"><%=exhibit%></a>' +
               '</div>'
    }

    messageKeys() {
        return {
            serviceAgreement: 'licenses.purchase.success.service_agreement_link',
            dataProcessingAgreement: 'licenses.purchase.success.data_processing_agreement_link',
            exhibit: 'licenses.purchase.success.exhibit_link',
        }
    }

    afterRender() {
        this.$serviceAgreement = this.find('.serviceAgreement')
        this.$dataProcessingAgreement = this.find('.dataProcessingAgreement')
        this.$invoice = this.find('.invoice')
        this.$exhibit = this.find('.exhibit')

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/successStep/DocumentsLinksList.js